module.exports = __webpack_public_path__ + "static/media/BHC-BNB.54bcbb77.png";